import { createFileRoute } from "@tanstack/react-router"
import { GovernanceBylawsPage } from "@/pages"
import { AuthorizationGate } from "@/components"
import { Resource, Action } from "@mimber/schema"

export const Route = createFileRoute(
  "/_authenticated/_organization/governance/bylaws"
)({
  component: () => (
    <AuthorizationGate resource={Resource.GOVERNANCE} action={Action.READ}>
      <GovernanceBylawsPage />
    </AuthorizationGate>
  ),
})
